import { useEffect, useState } from 'react'

const FRESHCHAT_DELAY_MS = 500

export function useFreshchatWidget() {
  const [isWidgetOpen, setIsWidgetOpen] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      const widget = window?.fcWidget
      if (widget) {
        widget.on('widget:opened', () => setIsWidgetOpen(true))
        widget.on('widget:closed', () => setIsWidgetOpen(false))
      }
      else {
        console.error('Freshchat widget not found')
      }
    }, FRESHCHAT_DELAY_MS)

    return () => {
      clearTimeout(timeout)
    }
  }, [])

  return { isWidgetOpen }
}
